import { render, staticRenderFns } from "./DashboardCongrat.vue?vue&type=template&id=85b60a1a"
import script from "./DashboardCongrat.vue?vue&type=script&lang=js"
export * from "./DashboardCongrat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports